<template>
  <div class="feature-wrapper">
    <ion-icon :name="icon" class="feature-icon"> </ion-icon>
    <div
      class="feature-name"
      :style='{ maxWidth: customMaxWidth ? customMaxWidth : "15ch" }'
    >
      {{ title }}
    </div>
    <div v-if="isNew" class="feature-new">{{$t("Novo!")}}</div>

    <svg v-if="hasNotification" class="feature-notification" xmlns="http://www.w3.org/2000/svg"  width="6" height="6" viewBox="0 0 6 6" fill="none">
      <circle cx="3" cy="3" r="3" fill="#FF445D"/>
    </svg>

    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'leftMenuFeatures',
    props: {
      icon: {
        required: true,
      },
      hasNotification: {
        required: false,
      },
      isNew: {
        required: false,
      },
      title: {
        required: true,
      },
      customMaxWidth: {
        type: String,
        required: false,
        default: null
      }
    },
    data() {
      return {

      }
    },
    methods: {

    }
  }
</script>

<style scoped lang="scss">
  .feature-wrapper {
    position: relative;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-items: center;
    color: #7E8DA7;
    font-size: 14px;
    gap: 12px;
    display: flex;
    padding: 2px 8px;
    margin-left: 5px;
    position: relative;
    width: fit-content;
  }

  .feature-wrapper:active {
    color: var(--darkBlue);
  }

  .feature-new {
    position: absolute;
    right: -32px;
    padding: 1px 4px;
    background: #1b59f8;
    border-radius: 8px;
    font-size: 9px;
    font-weight: 600;
    color: #fff;
  }

  .feature-icon {
    width: 22px;
    height: 22px;
  }

  .feature-wrapper:hover {
    color: var(--activeHoverSidebar);
  }

  .feature-name{
    max-width: 15ch;
  }

  .feature-notification {
    width: 6px;
    height: 6px;
    position: absolute;
    right: 0px;
    top: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/vue/views/components/leftMenuFeatures.vue